import { formattedValue } from '@hems/user/src/containers/report/chartFunctions';
import { DateHelper } from '@hems/util';
export function getOverviewOptions(data, t, locale, hasPV, hasESS) {
    return {
        colors: ['#002e54', '#cfcfcf', '#91c9d3', '#c3e76f', '#0068bf', '#8c8c8c'],
        chart: {
            type: 'column',
        },
        scrollbar: {
            enabled: false,
        },
        navigator: {
            enabled: false,
        },
        rangeSelector: {
            enabled: false,
        },
        title: {
            text: '',
        },
        xAxis: {
            labels: {
                style: {
                    color: '#292929',
                    fontFamily: 'actual , sans-serif',
                    fontSize: '20px',
                    fontWeight: '700',
                },
                formatter() {
                    return DateHelper.getLocalDate(this.value, { isMonthly: true });
                },
            },
            tickPositions: data.charge.map((item) => item.x),
        },
        yAxis: {
            min: 0,
            title: {
                text: '',
            },
            labels: {
                style: {
                    color: '#292929',
                    fontFamily: 'ng , sans-serif',
                    fontSize: '11px',
                },
                formatter() {
                    return `${this.value}k`;
                },
            },
            opposite: false,
        },
        legend: {
            enabled: true,
            borderRadius: 0,
            itemMarginTop: 1,
            squareSymbol: true,
            symbolWidth: 4,
            symbolPadding: 10,
            verticalAlign: 'bottom',
            y: 10,
            symbolRadius: 0,
            itemStyle: {
                color: '#292929',
                fontFamily: 'ng , sans-serif',
                fontSize: '10px',
                fontWeight: '700',
            },
        },
        tooltip: {
            shared: true,
            formatter() {
                const index = this.points != null ? this.points[0].point.index : -1;
                if (index < 0)
                    return '';
                if (!hasPV) {
                    return getNoPvTooltip(data, t, index, locale);
                }
                if (!hasESS) {
                    return getNoEssTooltip(data, t, index, locale);
                }
                return getPvModuleTooltip(data, t, index, locale);
            },
            useHTML: true,
        },
        plotOptions: {
            column: {
                pointPadding: 0.1,
                pointPlacement: 0,
                borderWidth: 0,
            },
        },
        series: getAnalysisSeries(data, t, hasPV, hasESS),
    };
}
function getAnalysisSeries(data, t, hasPV, hasESS) {
    let series = [
        {
            type: 'column',
            name: t('device.produced'),
            data: data.generation,
        },
        {
            type: 'column',
            name: t('device.consumed'),
            data: data.consumption,
        },
        {
            type: 'column',
            name: t('device.exported'),
            data: data.feedin,
        },
        {
            type: 'column',
            name: t('device.imported'),
            data: data.demand,
        },
    ];
    if (!hasPV) {
        series = [
            {
                type: 'column',
                name: t('device.consumed'),
                data: data.consumption,
            },
            {
                type: 'column',
                name: t('device.exported'),
                data: data.feedin,
            },
            {
                type: 'column',
                name: t('device.imported'),
                data: data.demand,
            },
        ];
    }
    if (hasESS) {
        series = series.concat([
            {
                type: 'column',
                name: t('device.charged'),
                data: data.charge,
            },
            {
                type: 'column',
                name: t('device.discharged'),
                data: data.discharge,
            },
        ]);
    }
    return series;
}
function getPvModuleTooltip(data, t, index, locale) {
    return `<table style="font-family:ng;font-size:11px;">
            <tr>
              <td style="color:#002e54;padding:0;font-weight:700;"> ${t('device.produced')} : </td>
              <td style="padding:0 0 0 2px">${formattedValue(data.generation[index].y ?? 0, locale)} kWh</td>
            </tr>
            <tr>
              <td style="color:#cfcfcf;padding:0;font-weight:700;"> ${t('device.consumed')} : </td>
              <td style="padding:0 0 0 2px">${formattedValue(data.consumption[index].y ?? 0, locale)} kWh</td>
            </tr>
            <tr>
              <td style="color:#91c9d3;padding:0;font-weight:700;"> ${t('device.exported')} : </td>
              <td style="padding:0 0 0 2px">${formattedValue(data.feedin[index].y ?? 0, locale)} kWh</td>
            </tr>
            <tr>
              <td style="color:#c3e76f;padding:0;font-weight:700;"> ${t('device.imported')} : </td>
              <td style="padding:0 0 0 2px">${formattedValue(data.demand[index].y ?? 0, locale)} kWh</td>
            </tr>
            <tr>
                <td style="color:#0068bf;padding:0;font-weight:700;"> ${t('device.charged')} : </td>
                <td style="padding:0 0 0 2px">${formattedValue(data.charge[index].y ?? 0, locale)} kWh</td>
              </tr>
              <tr>
                <td style="color:#8c8c8c;padding:0;font-weight:700;"> ${t('device.discharged')} : </td>
                <td style="padding:0 0 0 2px">${formattedValue(data.discharge[index].y ?? 0, locale)} kWh</td>
              </tr>
            </table>`;
}
function getNoPvTooltip(data, t, index, locale) {
    return `<table style="font-family:ng;font-size:11px;">
            <tr>
              <td style="color:#cfcfcf;padding:0;font-weight:700;"> ${t('device.consumed')} : </td>
              <td style="padding:0 0 0 2px">${formattedValue(data.consumption[index].y ?? 0, locale)} kWh</td>
            </tr>
            <tr>
              <td style="color:#91c9d3;padding:0;font-weight:700;"> ${t('device.exported')} : </td>
              <td style="padding:0 0 0 2px">${formattedValue(data.feedin[index].y ?? 0, locale)} kWh</td>
            </tr>
            <tr>
              <td style="color:#c3e76f;padding:0;font-weight:700;"> ${t('device.imported')} : </td>
              <td style="padding:0 0 0 2px">${formattedValue(data.demand[index].y ?? 0, locale)} kWh</td>
            </tr>
            <tr>
                <td style="color:#0068bf;padding:0;font-weight:700;"> ${t('device.charged')} : </td>
                <td style="padding:0 0 0 2px">${formattedValue(data.charge[index].y ?? 0, locale)} kWh</td>
              </tr>
              <tr>
                <td style="color:#8c8c8c;padding:0;font-weight:700;"> ${t('device.discharged')} : </td>
                <td style="padding:0 0 0 2px">${formattedValue(data.discharge[index].y ?? 0, locale)} kWh</td>
              </tr>
            </table>`;
}
function getNoEssTooltip(data, t, index, locale) {
    return `<table style="font-family:ng;font-size:11px;">
    <tr>
      <td style="color:#002e54;padding:0;font-weight:700;"> ${t('device.produced')} : </td>
      <td style="padding:0 0 0 2px">${formattedValue(data.generation[index].y ?? 0, locale)} kWh</td>
    </tr>
    <tr>
      <td style="color:#cfcfcf;padding:0;font-weight:700;"> ${t('device.consumed')} : </td>
      <td style="padding:0 0 0 2px">${formattedValue(data.consumption[index].y ?? 0, locale)} kWh</td>
    </tr>
    <tr>
      <td style="color:#91c9d3;padding:0;font-weight:700;"> ${t('device.exported')} : </td>
      <td style="padding:0 0 0 2px">${formattedValue(data.feedin[index].y ?? 0, locale)} kWh</td>
    </tr>
    <tr>
      <td style="color:#c3e76f;padding:0;font-weight:700;"> ${t('device.imported')} : </td>
      <td style="padding:0 0 0 2px">${formattedValue(data.demand[index].y ?? 0, locale)} kWh</td>
    </tr></table>`;
}
